import React from 'react';
import { BaseButton, ButtonSize, NativeButtonProps } from './BaseButton';

type Props = NativeButtonProps & { size?: ButtonSize };

export const GhostButton = (props: Props) => <BaseButton buttonStyle="ghost" {...props} />;
